import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    Paper,
    Button
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {
    setConfirmationModalState,
    adminSwitchMaintenanceMode,
} from 'store/actions';

const ReleasesTab = ({
    classes,
    setConfirmationModalState,
    adminSwitchMaintenanceMode,
}) => {
    
    const closeConfirmationModal = () => {
        setConfirmationModalState({ isModalOpen: false });
    }
    
    // const onShowMaintenanceMode = () => {
    //     setConfirmationModalState({ // Open confirmation modal
    //         isModalOpen: true,
    //         handleConfirmation: () => {
    //             console.log("Release has been confirmed. Starting preparations for the release");
    //             closeConfirmationModal();
    //             adminSwitchMaintenanceMode(true);
    //         },
    //         handleCancellation: closeConfirmationModal,
    //         contentText: `You are about to trigger a new release. Are you sure?`
    //     });
    // }

    const switchMaintenanceMode = (payload) => {
        adminSwitchMaintenanceMode(payload);
    }

    return (
        <Paper className={classes.tabRoot}> 
                <Button variant={'contained'}
                        color={'primary'}
                        style={{ marginRight: "16px"}}
                        onClick={() => switchMaintenanceMode(true)}>Show maintenance mode</Button>
                <Button variant={'contained'}
                        color={'primary'}
                        onClick={() => switchMaintenanceMode(false)}>Hide maintenance mode</Button>            
        </Paper>
    );
};
const styles = {
    tabRoot: {
        padding: '30px',
        // ToDo: temp width/height
        minHeight: '200px',
        minWidth: '400px'
    }
};

const mapStateToProps = (state) => ({
    // appMessages: state.adminState.appMessages,
});

const mapDispatchToProps = (dispatch) => ({
    setConfirmationModalState: confirmationModalState => dispatch(setConfirmationModalState(confirmationModalState)),
    adminSwitchMaintenanceMode: (isEnabled) => dispatch(adminSwitchMaintenanceMode(isEnabled)),
});

export default compose(
    withRouter,
    withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(ReleasesTab);